import React from 'react'
import { Building, Plus, Edit, MapPin } from 'lucide-react'

export function CentersManagement() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestion des Centres</h1>
          <p className="text-gray-600">Configuration des centres de vacances</p>
        </div>
        <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Plus className="h-4 w-4" />
          <span>Nouveau centre</span>
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          <div className="text-center text-gray-500">
            <Building className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Fonctionnalité à développer</h3>
            <p>La gestion complète des centres sera implémentée ici :</p>
            <ul className="mt-4 text-sm text-left max-w-md mx-auto space-y-2">
              <li>• Création et modification des centres</li>
              <li>• Gestion des adresses et contacts</li>
              <li>• Configuration des capacités</li>
              <li>• Attribution des coordinateurs</li>
              <li>• Paramètres spécifiques par centre</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}